import { useSelector } from 'react-redux';
import { useWizardEmit } from '@mwkt/react-magic-frame';
import { useEffect, useState } from 'react';
import { getNotification } from 'state/root-reducer';

import { MagicFrameInnerEvent, MagicFrameInnerNotificationEventData } from '../constants';

const useWizardNotificationEventsEmitter = () => {
  const [notificationsAmount, setNotificationsAmount] = useState(0);
  const list = useSelector(getNotification);
  const emitNotification = useWizardEmit<MagicFrameInnerNotificationEventData>({
    event: MagicFrameInnerEvent.Notification,
  });

  useEffect(() => {
    if (list.length > notificationsAmount) {
      const newNotifications = list.slice(notificationsAmount);

      newNotifications.forEach(({ message, type }) => {
        emitNotification({ message, color: type });
      });
    }

    setNotificationsAmount(list.length);
  }, [list]);
};

export default useWizardNotificationEventsEmitter;
